/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import cultureCardSlice, { CULTURE_CARD_KEY_IN_STORE } from './slice';
import { cultureCardSaga } from './sagas';

export class CultureCardModule {
	getRootKeyInStore(): string {
		return CULTURE_CARD_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return cultureCardSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return cultureCardSaga;
	}
}

export const moduleInstance = new CultureCardModule();
